import Icon from '../components/Icon.vue'

Icon.register({
  share: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M503.7 189.8c11.1 9.6 11.1 26.8 0 36.3l-176 152c-15.4 13.3-39.7 2.5-39.7-18.2v-87.9c-155.1 2.2-221.9 40.7-176.6 185.7 5 16.1-14.4 28.6-28.1 18.6-43.8-31.8-83.3-92.7-83.3-154.1 0-152.2 127.4-184.4 288-186.3v-80.1c0-20.7 24.3-31.5 39.7-18.2z'
      }
    ]
  }
})
